import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';

// Custom SVG Icons (matching MarketCarInfo)
const GaugeIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v2M6 12h2M18 12h-2M12 12l3-3" strokeLinecap="round" />
  </svg>
);

const VinIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M7 8h10M7 12h6M7 16h8" strokeLinecap="round" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 21s-8-7.5-8-12a8 8 0 1116 0c0 4.5-8 12-8 12z" />
    <circle cx="12" cy="9" r="3" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SourceIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SalvageCarInfo = ({ carDetail, setCompare, compare, setLoading, pageType }) => {
  const navigate = useNavigate();
  const { vin, title, state, city, images, seller_name, mileage, bid, domain_id } = carDetail;
  const isSelected = compare.map((item) => item?.vin).includes(vin);

  const handleComparison = (car, key) => {
    if (key === "add") {
      setCompare([...compare, car]);
      localStorage.setItem("compareSalvage", JSON.stringify([...compare, car]));
    }
    if (key === "remove") {
      let filteredData = compare.filter((item) => item?.vin !== car.vin)
      setCompare(filteredData);
      localStorage.setItem("compareSalvage", JSON.stringify(filteredData));
    }
  }

  const formatBid = (bidValue) => {
    if (!bidValue) return 'No Auction in last 6 months';
    return `$${Number(bidValue).toLocaleString()}`;
  };

  const getSource = (domainId) => {
    if (domainId === 3) return "Copart";
    if (domainId === 1) return "IAA";
    return "";
  };

  const getImageUrl = () => {
    try {
      if (images && images[0]) {
        const parsed = JSON.parse(images[0]);
        return parsed[0] || null;
      }
    } catch {
      return null;
    }
    return null;
  };

  return (
    <div className="vehicle-card group">
      {/* Image Container */}
      <div className="vehicle-card-image">
        {getImageUrl() ? (
          <img src={getImageUrl()} alt={title} />
        ) : (
          <div className="vehicle-card-no-image">
            <svg className="w-16 h-16 text-slate-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <rect x="2" y="6" width="20" height="12" rx="2" />
              <circle cx="7" cy="18" r="2" />
              <circle cx="17" cy="18" r="2" />
              <path d="M5 6l2-3h10l2 3" />
            </svg>
            <span>No Image</span>
          </div>
        )}

        {/* Gradient Overlay */}
        <div className="vehicle-card-overlay" />

        {/* Select Button */}
        <div className="vehicle-card-select">
          {isSelected ? (
            <button
              className="vehicle-btn-selected"
              onClick={() => handleComparison(carDetail, "remove")}
            >
              <CheckIcon />
              <span>Selected</span>
            </button>
          ) : (
            compare.length < 4 && (
              <button
                className="vehicle-btn-select"
                onClick={() => handleComparison(carDetail, "add")}
              >
                <span>+ Compare</span>
              </button>
            )
          )}
        </div>

        {/* Source Badge */}
        {getSource(domain_id) && (
          <div className="vehicle-card-year">{getSource(domain_id)}</div>
        )}
      </div>

      {/* Content */}
      <div className="vehicle-card-content">
        {/* Header */}
        <div className="vehicle-card-header">
          <h3 className="vehicle-card-title">{title}</h3>
          <div className="vehicle-card-price">{formatBid(bid)}</div>
        </div>

        {/* Specs Grid */}
        <div className="vehicle-card-specs">
          <div className="vehicle-spec">
            <VinIcon />
            <span className="vehicle-spec-value">{vin?.toUpperCase()?.slice(0, 11)}...</span>
          </div>
          <div className="vehicle-spec">
            <GaugeIcon />
            <span className="vehicle-spec-value">{mileage ? `${Number(mileage).toLocaleString()} Miles` : 'N/A'}</span>
          </div>
          <div className="vehicle-spec">
            <LocationIcon />
            <span className="vehicle-spec-value vehicle-spec-location">{city}, {state}</span>
          </div>
          {seller_name && (
            <div className="vehicle-spec">
              <SourceIcon />
              <span className="vehicle-spec-value">{seller_name}</span>
            </div>
          )}
        </div>

        {/* Action Button */}
        <button
          className="vehicle-card-btn"
          onClick={() => {
            navigate(`/product_page/${vin}?isSalvage=${pageType === "SalvageCars"}`, {
              state: { photoUrls: JSON.parse(images), selectedProduct: carDetail }
            })
          }}
        >
          <span>View Details</span>
          <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SalvageCarInfo;
